import Swiper from 'swiper';

const mobileSwiperOptions = {
  slideClass: 'js-stocks-slide',
  wrapperClass: 'js-stocks-slider-wrapper',
  slidesPerView: 1.5,
  spaceBetween: 20,
};

const desktopSwiperOptions = {
  slideClass: 'js-stocks-slide',
  wrapperClass: 'js-stocks-slider-wrapper',
  slidesPerView: 4,
  spaceBetween: 25,
  navigation: {
    nextEl: '.js-stocks-next',
    prevEl: '.js-stocks-prev',
  },
  breakpoints: {
    1240: {
      slidesPerView: 4,
    },
    960: {
      slidesPerView: 3,
    },
    700: {
      slidesPerView: 2,
    },
  },
};

export default class SwitchStock {
  constructor(data) {
    this._container = document.getElementById(data.container);
    this._slider = this._container.querySelector('.js-stocks-slider');
    this._sliderWrapper = this._container.querySelector('.js-stocks-slider-wrapper');
    this._slides = this._container.querySelectorAll('.js-stocks-slide');
    this._switches = this._container.querySelectorAll('.js-stocks-switch');
    this._switchList = this._container.querySelector('.js-stocks-switch-list');
    this._switchSlider = this._container.querySelector('.js-stocks-switch-slider');
    this._mode = data.mode;
    this._swiper = null;
    this._swiperInited = false;
    this._mobile = this._isMobile();

    this.init();
  }

  _isMobile() {
    return window.innerWidth < 700;
  }

  _switchMode(mode) {
    if (mode && mode === this._mode) {
      return 0;
    } else if (mode) {
      this._mode = mode;
    }

    if (this._mode === 'list') {
      this._setList();
    } else if (this._mode === 'slider') {
      this._setSlider();
    }
  }

  _setList() {
    this._container.setAttribute('data-mode', 'list');

    if (this._swiper) {
      this._swiper.destroy();
    }

    this._swiperInited = false;
  }

  _setSlider() {
    this._container.setAttribute('data-mode', 'slider');

    this._swiper = new Swiper(this._slider, desktopSwiperOptions);
    this._swiperInited = true;
  }

  init() {
    if (this._isMobile()) {
      this._container.setAttribute('data-mode', 'slider');

      this._swiper = new Swiper(this._slider, mobileSwiperOptions);
      this._swiperInited = true;
    } else {
      this._switchMode();
    }

    if(this._switchList) {
      this._switchList.addEventListener('click', this._setList.bind(this));
      this._switchSlider.addEventListener('click', this._setSlider.bind(this));
    }

    window.addEventListener(`resize`, () => {
      let _this = this;

      if (this._isMobile() === this._mobile) {
        return;
      }

      this._mobile = this._isMobile();

      if (window.innerWidth >= 700) {
        if (this._swiperInited) {
          _this._swiper.destroy();
          this._swiperInited = false;
        }
        this._setSlider();
      } else {
        this._container.setAttribute('data-mode', 'slider');

        if (this._swiperInited) {
          _this._swiper.destroy();
        }
        _this._swiper = new Swiper(this._slider, mobileSwiperOptions);
        this._swiperInited = true;
      }

      this._switches.forEach((x) => {
        x.classList.remove('is-active');
      });
      this._switchSlider.classList.add('is-active');
    });
  }
}
